import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface CheckoutProductsWizard {
    amount: string;
    discount: number
    name: string;
    quantity: number;
    realAmount: string;
}

export interface CheckoutPointsWizard {
    amount: string;
    amountDiscounted: string;
    amountDiscountedWc: string;
    quantity: number;
    quantityDiscounted: number;
    totalDiscountAmount: string;
    totalDiscountAmountWc: string;
}

export interface CheckoutDepositWizard {
    totalDepositAmount: string;
    totalDepositAmountWc: string;
    depositType: string;
}

export interface CheckoutWizard {
    advance: boolean;
    clientId: string;
    currency: string;
    deposit: CheckoutDepositWizard;
    points: CheckoutPointsWizard;
    products: CheckoutProductsWizard[];
    ticketGid: string;
    totalAmount: string;
    totalAmountWc: string;
    usePoints: boolean;
    payDeposit: boolean;
    loaded: boolean;
}

export function createInitialState(): CheckoutWizard {
    return {
        products: [],
        points: {
            amount: '',
            amountDiscounted: '',
            amountDiscountedWc: '0,00',
            quantity: 0,
            quantityDiscounted: 0,
            totalDiscountAmount: '',
            totalDiscountAmountWc: '0',
        },
        clientId: '',
        currency: '',
        ticketGid: '',
        totalAmount: '0',
        totalAmountWc: '',
        advance: false,
        usePoints: false,
        deposit: {
            totalDepositAmount: '',
            totalDepositAmountWc: '',
            depositType: '0',
        },
        payDeposit: false,
        loaded: false,
    };
}

export function parseCheckoutWizardProductObject(data: any): CheckoutProductsWizard {
    return {
        ...data,
        realAmount: data.real_amount,
    };
}

export function parseCheckoutWizardProductsArray(products: any): CheckoutProductsWizard[] {
    return products.map((product: any) => parseCheckoutWizardProductObject(product));
}

export function parseCheckoutWizardPointsObject(data: any): CheckoutPointsWizard {
    return {
        ...data,
        amountDiscounted: data.amount_discounted,
        amountDiscountedWc: data.amount_discounted_wc,
        quantityDiscounted: data.quantity_discounted,
        totalDiscountAmount: data.total_discount_amount,
        totalDiscountAmountWc: data.total_discount_amount_wc,
    };
}

export function parseCheckoutWizardDepositObject(data: any): CheckoutDepositWizard {
    return {
        totalDepositAmount: data.total_deposit_amount,
        totalDepositAmountWc: data.total_deposit_amount_wc,
        depositType: data.deposit_type,
    };
}

export function parseCheckoutWizardObject(data: any, useDeposit: boolean): CheckoutWizard {
    return {
        ...data,
        products: parseCheckoutWizardProductsArray(data.products),
        points: parseCheckoutWizardPointsObject(data.points),
        advance: data.advance === '-1',
        usePoints: data.use_points === '-1',
        totalAmount: data.total_amount,
        totalAmountWc: data.total_amount_wc,
        ticketGid: data.ticket_gid,
        clientId: data.client_id,
        deposit: parseCheckoutWizardDepositObject(data.deposit),
        payDeposit: parseCheckoutWizardDepositObject(data.deposit).depositType === '-1' ? true : useDeposit,
        loaded: true,
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'checkout-settings', resettable: true })
export class CheckoutWizardStore extends Store<CheckoutWizard> {
    constructor() {
        super(createInitialState());
    }
}
